import theme from "../../../styles/theme";
import { ButtonSys } from "./styles";

interface IButtonProps {
  label: string;
  disabled?: boolean;
  onClick?: (event: React.KeyboardEvent | React.MouseEvent) => void;
  color?: string;
  bgColor?: string;
  className?: string;
  hoverBgcolor?: string;
  disabledBgColor?: string;
  type?: "submit" | "button" | "reset";
  startIcon?: React.ReactNode;
  borderColor?: string;
}

export const ButtonPage: React.FC<IButtonProps> = ({
  label,
  disabled = false,
  color = "#fff",
  bgColor = theme.colors.brown.primary,
  hoverBgcolor = theme.colors.brown.capivaraLight,
  disabledBgColor = theme.colors.brown.primaryDisabled,
  type = "button",
  startIcon,
  className,
  onClick,
  borderColor = "",
}) => {
  return (
    <ButtonSys
      className={className}
      disabled={disabled}
      color={color}
      bgColor={bgColor}
      hoverBgcolor={hoverBgcolor}
      disabledBgColor={disabledBgColor}
      type={type}
      onClick={onClick}
      borderColor={borderColor}
    >
      {startIcon}
      {label}
    </ButtonSys>
  );
};
